export const FETCH_CHATS_REQUEST = 'FETCH_CHATS_REQUEST';
export const FETCH_CHATS_SUCCESS = 'FETCH_CHATS_SUCCESS';
export const FETCH_CHATS_FAILURE = 'FETCH_CHATS_FAILURE';

export const FETCH_MESSAGES_REQUEST = 'FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_SUCCESS = 'FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_FAILURE = 'FETCH_MESSAGES_FAILURE';

export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';

export const UPDATE_CHAT_REALTIME = 'UPDATE_CHAT_REALTIME';
export const UPDATE_MESSAGES_REALTIME = 'UPDATE_MESSAGES_REALTIME';
export const NEW_MESSAGE_RECEIVED = 'NEW_MESSAGE_RECEIVED';

export const OPEN_CHAT_FROM_ORDERS_OR_CREATE_NEW_CHAT_REQUEST = 'OPEN_CHAT_FROM_ORDERS_OR_CREATE_NEW_CHAT_REQUEST';
export const OPEN_CHAT_FROM_ORDERS_OR_CREATE_NEW_CHAT_SUCCESS = 'OPEN_CHAT_FROM_ORDERS_OR_CREATE_NEW_CHAT_SUCCESS';
export const OPEN_CHAT_FROM_ORDERS_OR_CREATE_NEW_CHAT_FAILURE = 'OPEN_CHAT_FROM_ORDERS_OR_CREATE_NEW_CHAT_FAILURE';

export const SET_SELECTED_CHAT_ID = 'SET_SELECTED_CHAT_ID';
export const MARK_MESSAGES_AS_READ = 'MARK_MESSAGES_AS_READ';
export const RESET_SELECTED_CHAT_ID = 'RESET_SELECTED_CHAT_ID';